























































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import PolicyScriptCmp from "../PolicyScriptCmp.vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
} from "@vue/composition-api";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { SharedState } from "@/common/state";
import { UseStatefulFn } from "@/common/composition/loading";
import * as api from "./data/api";
import { emptyFn } from "@/fp";
import { AppScript } from "@/views/playbooks/data/models";
import * as script_api from "@/views/playbooks/data/api";
import { InfoTypeHelper } from "@/common/models";
export default Vue.extend({
  components: {
    Modal,
    PolicyScriptCmp,
    DropDownSimple,
  },
  // label_id,label_name
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "94rem",
      height: "65rem",
      withTopRightCloseBtn: true,
    };

    const script: Ref<AppScript | null> = ref(null);

    const active_policy_option = ref("");
    const is_policy_active = computed(() => {
      if (selected_item.value && active_policy_option.value) {
        return active_policy_option.value == selected_item.value.id;
      }
      return false;
    });

    const [items, selected_item, set_selected_item] = UseDropdownItems([
      { id: "high_severity", name: "on any high severity event" },
      {
        id: "external_high_severity",
        name:
          "on any high severity exposure to an <b>untrusted organization</b> or <b>personal contact</b>",
      },
      {
        id: "personal_address_high_severity",
        name:
          "on any high severity exposure to an <b>untrusted personal contact</b>",
      },
    ]);

    const [
      l0_items,
      selected_l0_item,
      set_selected_l0_item,
      ,
      add_l0_watcher,
    ] = UseDropdownItems<{ id: string; name: string }>(
      SharedState.l0InfoTypes.value
        .filter(
          ({ id }) =>
            id !== SharedState.default_label_id.value &&
            id !== InfoTypeHelper.REGULATED_ID()
        )
        .map(({ id, labelName }) => {
          return { id, name: labelName + " information" };
        })
    );

    const texts = computed(() => {
      const { label_id, label_name } = props.modalData as {
        label_id: string;
        label_name: string;
      };
      return {
        // @ts-ignore
        title: `Ask for justification for event with ${label_name} information`,
        desc: "this is the description text",
        details: "this is the details text",
        mitigation: "this is the mitigation text",
        threats: ["one", "two", "three", "four"],
      };
    });

    const [activate, is_during_activation] = UseStatefulFn(async () => {
      await api.toggle_l0_policy_status({
        id: selected_l0_item.value!.id,
        activate: true,
        selected_policy: selected_item.value!.id,
      });
      active_policy_option.value = selected_item.value!.id;
    });

    const [deactivate, is_during_deactivation] = UseStatefulFn(async () => {
      await api.toggle_l0_policy_status({
        id: selected_l0_item.value!.id,
        activate: false,
        selected_policy: selected_item.value!.id,
      });
      active_policy_option.value = "";
    });

    const [init, is_loading, is_initial_load] = UseStatefulFn<
      string,
      void,
      void
    >(async (label_id) => {
      const res = await api.get_justification_policy_status_list();
      console.log("label_id::", label_id, " res::", res);
      if (res.success) {
        const { is_active, policy_id } = res.value.find(
          (f) => f.id === label_id
        )!;
        active_policy_option.value = is_active ? policy_id : "";
        if (policy_id && is_active) {
          set_selected_item(policy_id);
        }
      }
    });

    const show_activate_btn_loader = computed(
      () => !is_initial_load.value && is_loading.value
    );

    const show_full_loader = computed(
      () => is_initial_load.value && is_loading.value
    );

    const subs = {
      l0: emptyFn(),
    };

    onMounted(async () => {
      const res = await script_api.get_full_script(
        "423ac7a6-3e1a-4d11-b916-8c8ffec0a560"
      );
      if (res.success) {
        script.value = res.value;
      }
      const { label_id } = props.modalData as {
        label_id: string;
        label_name: string;
      };
      set_selected_l0_item(label_id);
      await init(label_id);
      subs.l0 = add_l0_watcher(async (id) => {
        await init(id);
      });
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      config,
      is_loading,
      is_policy_active,
      is_during_activation,
      texts,
      activate,
      deactivate,
      items,
      script,
      selected_item,
      set_selected_item,
      l0_items,
      selected_l0_item,
      set_selected_l0_item,
      show_activate_btn_loader,
      show_full_loader,
    };
  },
});
